import React from 'react'
import { makeStyles } from '@mui/styles'
import { Container } from '@mui/material'

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: ({ paddingTopMobile }) =>
        paddingTopMobile || paddingTopMobile === 0
          ? theme.spacing(paddingTopMobile)
          : theme.spacing(7),
      paddingBottom: ({ paddingBottomMobile }) =>
        paddingBottomMobile || paddingBottomMobile === 0
          ? theme.spacing(paddingBottomMobile)
          : theme.spacing(9)
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: ({ paddingTop }) =>
        paddingTop || paddingTop === 0
          ? theme.spacing(paddingTop)
          : theme.spacing(15),
      paddingBottom: ({ paddingBottom }) =>
        paddingBottom || paddingBottom === 0
          ? theme.spacing(paddingBottom)
          : theme.spacing(15)
    }
  }
}))

export const ContentWrapper = ({
  maxWidth = 'lg',
  className,
  paddingTop,
  paddingTopMobile,
  paddingBottom,
  paddingBottomMobile,
  children
}) => {
  const classes = useStyles({ paddingTop, paddingTopMobile, paddingBottom, paddingBottomMobile })
  const rootClass = [classes.root, className].filter(Boolean).join(' ')
  return (
    <div className={rootClass}>
      {children && (
        <Container maxWidth={maxWidth}>
          {children}
        </Container>
      )}
    </div>
  )
}

export default ContentWrapper
